import { Injectable, OnDestroy, signal, inject, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';

@Injectable({ providedIn: 'root' })
export class AppLifecycleService implements OnDestroy {
  private zone = inject(NgZone);

  private _isActive = signal<boolean>(true);
  readonly isActive = this._isActive.asReadonly();

  private listenerHandle: any | null = null;

  constructor() {
    if (Capacitor.isNativePlatform()) {
      App.addListener('appStateChange', (state: any) => {
        this.zone.run(() => {
          this._isActive.set(!!state.isActive);
        });
      }).then(handle => {
        this.listenerHandle = handle;
      });
    }
  }

  ngOnDestroy(): void {
    if (this.listenerHandle) {
      try {
        this.listenerHandle.remove();
      } catch {}
      this.listenerHandle = null;
    }
  }
}
